import type { StaffNote } from '../types/payloads/melody_staff.types';

const PITCH_TO_SPANISH: Record<string, string> = {
  C: 'Do',
  D: 'Re',
  E: 'Mi',
  F: 'Fa',
  G: 'Sol',
  A: 'La',
  B: 'Si',
};

/** Convierte pitch Vex (G5) a nombre chileno (Sol). */
export function pitchToSpanishLabel(pitch: string): string {
  const letter = String(pitch || 'C').charAt(0).toUpperCase();
  return PITCH_TO_SPANISH[letter] || letter;
}

/** Posición Y relativa en pentagrama (0 = línea central, negativo = arriba). */
export function staffStepForPitch(pitch: string, clef: 'treble' | 'bass' = 'treble'): number {
  const letter = String(pitch || 'C4').charAt(0).toUpperCase();
  const octave = Number(String(pitch).match(/\d+/)?.[0] ?? 4);
  const diatonic: Record<string, number> = { C: 0, D: 1, E: 2, F: 3, G: 4, A: 5, B: 6 };
  const base = clef === 'treble' ? 4 * 7 + diatonic.G : 3 * 7 + diatonic.F;
  const note = octave * 7 + (diatonic[letter] ?? 0);
  return base - note;
}

export function buildStaffSvgFragment(
  notes: StaffNote[],
  opts?: { clef?: 'treble' | 'bass'; highlightId?: string; width?: number },
): string {
  const clef = opts?.clef ?? 'treble';
  const w = opts?.width ?? 280;
  const h = 88;
  const left = 36;
  const lineGap = 10;
  const lines = [0, 1, 2, 3, 4].map((i) => 20 + i * lineGap);
  const clefChar = clef === 'treble' ? '𝄞' : '𝄢';

  const noteDots = notes
    .map((note, i) => {
      const step = staffStepForPitch(note.pitch, clef);
      const y = 40 - step * (lineGap / 2);
      const x = left + 48 + i * 44;
      const fill = opts?.highlightId === note.id ? '#7c3aed' : '#0a0a0a';
      return `<ellipse cx="${x}" cy="${y}" rx="5.5" ry="4" fill="${fill}"/>`;
    })
    .join('');

  const staffLines = lines.map((y) => `<line x1="${left}" y1="${y}" x2="${w - 12}" y2="${y}" stroke="#0a0a0a" stroke-width="1.5"/>`).join('');

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" role="img" aria-label="Fragmento de pentagrama">
    ${staffLines}
    <text x="${left + 4}" y="48" font-size="28" font-family="serif">${clefChar}</text>
    ${noteDots}
  </svg>`;
}
